import React, { useEffect, useState } from "react";
import { ResponsiveDeviceType } from "../../../widget/layouts/ScreenMedia";
import AppTranslation from "../../../service/app_translation/AppTranslation";
import { MainBodyContainer } from "../../../widget/common/ui/MainContainer";
import Scaffold from "../../../widget/layouts/Scaffold";
import { HomeGuestUserContextProvider } from "../../../provider/home_guest_user/guest_home/HomeGuestUserContextProvider";
import GuestUserFormContent from "./GuestUserFormContent";
import { useLocation } from "react-router-dom";
import GusetUserFormButton from "./widget/GusetUserFormButton";
import { GuestUserFormContextProvider } from "../../../provider/home_guest_user/guest_user_form/GuestUserFormContextProvider";

const GuestUserFormScreen = () => {
  const type: number = ResponsiveDeviceType();

  const location = useLocation();

  const [title, setTitle] = useState<string>("");

  const setupTitle = () => {
    const pathArr = location.pathname.split("/");
    const pathName = pathArr[pathArr.length - 1];

    setTitle(
      pathName === "form-general"
        ? AppTranslation.text("general_form")
        : AppTranslation.text("feedback_form")
    );
  };

  useEffect(() => {
    setupTitle();
    // eslint-disable-next-line
  }, []);

  return (
    <GuestUserFormContextProvider>
      <HomeGuestUserContextProvider>
        <Scaffold
          appBarTitle={title}
          bottomNavigationButton={<GusetUserFormButton />}
        >
          <MainBodyContainer>
            <GuestUserFormContent type={type} />
          </MainBodyContainer>
        </Scaffold>
      </HomeGuestUserContextProvider>
    </GuestUserFormContextProvider>
  );
};

export default GuestUserFormScreen;
export const routeNameFormGeneral = "/guest/form-general";
export const routeNameFormFeedback = "/guest/form-feedback";
